<template>
  <li class="stateroomItem" :class="{ 'special-stateroom-qiaohu': isQiaohu, 'special-stateroom-starrySky': isStarrySky }" v-if="stateroomShow">
    <div class="list_box fix stateroomOnly">
      <div class="f-fl">
        <div class="img_box stateroomImage" @click="onStateroomClicked">
          <img :src="imageUrl" />
          <img
              class="qiaohu_tag"
              v-if="isQiaohu"
              src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png"
          />
          <img
              class="qiaohu_tag"
              v-else-if="isStarrySky"
              src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png"
          />
          <img class="suite-tag"
               v-if="stateroomType === 'DELUXE' && stateroomTag >= 0"
               :src="GlobalData.suiteImgValue[stateroomTag]"/>
<!--          <img class="suite-tag"-->
<!--               v-if="stateroomTag && stateroomTag.indexOf('银钻')>=0"-->
<!--               :src="`${imgUrl}/cruiseDetail/suite/suite-sea.jpg`"/>-->
<!--          <img class="suite-tag"-->
<!--               v-else-if="stateroomTag && stateroomTag.indexOf('金钻')>=0"-->
<!--               :src="`${imgUrl}/cruiseDetail/suite/suite-sky.jpg`"/>-->
<!--          <img class="suite-tag"-->
<!--               v-else-if="stateroomTag && stateroomTag.indexOf('星钻')>=0"-->
<!--               :src="`${imgUrl}/cruiseDetail/suite/suite-star.jpg`"/>-->
        </div>
      </div>
      <div class="f-fl">
        <div class="ship_info">
          <div class="ship_title">
            {{ stateroomName }}
            <img
              class="qiaohu_tag"
              v-if="isQiaohu"
              src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png"
              @click="onShowQiaohuPopup()"
            />
            <img
                class="qiaohu_tag"
                v-else-if="isStarrySky"
                src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png"
                @click="onShowStarrySkyPopup()"
            />
            <img class="deluxe-tag"
              v-if="stateroomType === 'DELUXE' && stateroomTag >= 0"
              @click="onShowStateroomSuitePopup(stateroom.suiteImageUrl)"
              :src="GlobalData.suiteTagImgValue[stateroomTag]"/>
<!--            <img class="deluxe-tag" -->
<!--              v-if="stateroomTag && stateroomTag.indexOf('银钻')>=0" -->
<!--              @click="onShowStateroomSuitePopup(stateroom.suiteImageUrl)"-->
<!--              :src="`${imgUrl}/cruiseDetail/suite/suite-tag-03.png`"/>-->
<!--            <img class="deluxe-tag"-->
<!--              v-else-if="stateroomTag && stateroomTag.indexOf('金钻')>=0" -->
<!--              @click="onShowStateroomSuitePopup(stateroom.suiteImageUrl)"-->
<!--              :src="`${imgUrl}/cruiseDetail/suite/suite-tag-02.png`"/>-->
<!--            <img class="deluxe-tag" -->
<!--              v-else-if="stateroomTag && stateroomTag.indexOf('星钻')>=0" -->
<!--              @click="onShowStateroomSuitePopup(stateroom.suiteImageUrl)"-->
<!--              :src="`${imgUrl}/cruiseDetail/suite/suite-tag-01.png`"/>-->
<!--            <i-->
<!--              v-else-if="stateroomTag.length > 0"-->
<!--              class="offer_label suite_label"-->
<!--              @click="onShowStateroomSuitePopup(stateroom.suiteImageUrl)"-->
<!--              >{{ stateroomTag }}</i-->
<!--            >-->
          </div>
          <div class="ship_parameter">
            <span>舱房：{{ stateroom.stateroomArea || '--' }}</span>
            <span>阳台：{{ stateroomBalconyArea || '--' }}</span>
            <span>楼层：{{ stateroom.stateroomFloorInfo || '--' }}</span>
          </div>
          <template v-if="stateroomType === 'DELUXE' && stateroomTag >= 0">
            <DeviceFeatureTags :view-num="2" is-detail :tags="stateroom.deviceFeatureTags" @submit="onStateroomClicked"></DeviceFeatureTags>
          </template>
          <template v-else>
            <DeviceFeatureTags is-detail :tags="stateroom.deviceFeatureTags" @submit="onStateroomClicked"></DeviceFeatureTags>
          </template>
        </div>
        <div class="price nrpPrice">
          <div class="price-num" v-if="!isQiaohu">
            {{ priceType }}(含税)
            <em class="symbol">￥</em>
            <span class="num">{{ netAmountStr }} </span>
            <em>/人起</em>
            <span v-if="amountPerNight" class="average-price">平均每晚￥{{amountPerNight}}/人起</span>
          </div>
          <div class="offer_price" v-else>
            <em>￥</em>
            <span class="num">{{ netAmountStr }}</span
            >/人起(含税)
          </div>
<!--          <del class="original_price" v-if="!isQiaohu">-->
<!--            ￥{{ originalAmountStr }}/人起-->
<!--          </del>-->
          <div class="return_label" @click="onSelectNrpChange($event)">
            <span
              class="js-NRPPrice"
              :class="{ cur: selectNrp }"
              v-show="hasNrp"
              >{{ getNrpTitle(true) }}</span
            >
            <span
              class="js-UnNRPPrice"
              :class="{ cur: !selectNrp }"
              v-show="hasRp"
              >{{ getNrpTitle(false) }}</span
            >
          </div>
          <NrpDotTag
            :isNrp="selectNrp"
            :isFortyEightHoursNrpCruise="isFortyEightHoursNrpCruise"
          />
          <FourPeopleBookingTag v-if="stateroom.stateroomCategoryCode === 'US'" />
          <!--特殊礼遇-->
          <div class="specialBookingStateroom_title" v-if="isBirthday">
            <span>支持收费附加服务:</span>
            <span
              class="button"
              @click="onShowStateroomSuitePopup(specialBookingInfo.image)"
            >
              <img
                src="https://resource.rcclchina.com.cn/wechatMiniProgram/WechatMiniProgramImage/birthdayRoom/birthday_icon.png"
                alt=""
              />
              {{ "皇家生日礼遇" }}
            </span>
          </div>
        </div>
      </div>
      <div class="f-fr">
        <div class="detail_add_btn">
          <span
            class="less"
            :class="{ disabled: shoppingCartNum == 0 }"
            @click="shoppingCartDelete($event)"
          ></span>
          <input
            type="text"
            class="stateroomNumber"
            :value="shoppingCartNum"
            placeholder="0"
            readonly="readonly"
          />
          <span class="add" @click="shoppingCartAdd($event)"></span>
        </div>
<!--        <div class="c_surplus_room_num">*该房型仅剩2间</div>-->
      </div>
      <div class="f-fr errMsg" v-show="errMsg && errMsg.length > 0">
        <div class="errMsgText" v-html="errMsg"></div>
        <img
          src="https://resource.rcclchina.com.cn/tui2/info/close.png"
          class="clean"
          @click="closeErrMsg"
        />
      </div>
      <div class="hover-bg"></div>
    </div>
  </li>
</template>

<script>
import nrpConfig from "@/utilities/nrpConfig";
import bookingHelper from "@/utilities/bookingHelper";
import {gioTracking} from "@/utilities/tools";
import { SpecialBookingType } from "@/utilities/specialBookingHelper";
const NrpDotTag = () => import("@/components/Booking/NrpDotTag.vue");
const FourPeopleBookingTag = () => import("@/components/Booking/FourPeopleBookingTag.vue");
const DeviceFeatureTags = ()=> import("@/components/Cruise/CruiseDetail/DeviceFeatureTags.vue");
export default {
  name: "StateroomItem",
  components: {
    NrpDotTag,
    FourPeopleBookingTag,
    DeviceFeatureTags
  },
  props: {
    shipCode: {
      type: String,
      default() {
        return "";
      },
    },
    sailDate: {
      type: String,
      default() {
        return "";
      },
    },
    packageCode: {
      type: String,
      default() {
        return "";
      },
    },
    stateroom: {
      type: Object,
      default() {
        return {};
      },
    },
    guestNumber: {
      type: Number,
      default() {
        return 0;
      },
    },
    shoppingCarts: {
      type: Array,
      default() {
        return [];
      },
    },
    stateroomType: {
      type: String,
      default() {
        return "";
      },
    },
    qiaohuGroup: {
      type: Object,
      default() {
        return {};
      },
    },
    onShoppingCartAdd: {
      type: Function,
    },
    onShoppingCartDelete: {
      type: Function,
    },
    showStateroomDetail: {
      type: Function,
    },
    showStateroomSuitePopup: {
      type: Function,
    },
    showQiaohuPopup: {
      type: Function,
    },
    showStarrySkyPopup: {
      type: Function
    },
    isFortyEightHoursNrpCruise: {
      type: Boolean,
    },
    specialBookingInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    suiteTagSelected: {
      type: Number,
      default: -1
    },
    nrpDefaultSelectedType: {
      type: Number
    }
  },
  data() {
    return {
      selectNrp: false,
      errMsg: "",
      errMsgTimeout: null,
      imgUrl: process.env.VUE_APP_IMG_URL,
      stateroomShow: true
    };
  },
  beforeMount() {
    this.initSelectNrp();
  },
  methods: {
    initSelectNrp() {
      if (!this.stateroom.price || this.stateroom.price.length == 0) {
        return;
      }
      let nrp = 0;
      const nrpPrice = this.stateroom.price.filter((r) => r.isnrp);
      nrp = nrpPrice.length > 0 ? nrpPrice[0].netAmount : 0;
      let rp = 0;
      const rpPrice = this.stateroom.price.filter((r) => !r.isnrp);
      rp = rpPrice.length > 0 ? rpPrice[0].netAmount : 0;

      // 暂时默认显示RP价格
      // if (nrp > 0 && nrp <= rp) {
      //     this.selectNrp = true
      // } else {
      //     this.selectNrp = false
      // }

      //nrpDefaultSelectedType 0:默认-按nrp 1:常规rp | 2:收费nrp
      if (rp > 0 && nrp > 0) {
        this.selectNrp = this.nrpDefaultSelectedType === 0 || this.nrpDefaultSelectedType === 2;
      } else if (rp > 0) {
        this.selectNrp = false;
      } else if (nrp > 0) {
        this.selectNrp = true;
      }
    },
    onSelectNrpChange(e) {
      e.stopPropagation();
      if (this.selectNrp == false && this.hasNrp) {
        this.selectNrp = true;
      } else if (this.selectNrp == true && this.hasRp) {
        this.selectNrp = false;
      }
    },
    async shoppingCartAdd(e) {
      e.stopPropagation();
      const price = this.stateroom.price.filter(
        (r) => r.isnrp == this.selectNrp
      );
      if (!price || price.length == 0) {
        return;
      }
      let model = {
        shipCode: this.shipCode,
        sailDate: this.sailDate,
        productPackageId: -1,
        packageId: this.packageCode,
        stateroomCategoryCode: this.stateroom.stateroomCategoryCode,
        stateroomClass: this.stateroomType,
        fareCode: price[0].fareCode,
        guestNumber: this.guestNumber,
        originAmount: price[0].originalAmount / this.guestNumber,
        netAmount: price[0].netAmount / this.guestNumber,
        amountPerNight: price[0].amountPerNight,
        isNrp: this.selectNrp,
        groupAgencyId: "",
        groupAgencyName: "",
        requestsequence: "",
        groupType: "",
        groupId: "",
        connectId: "",
      };

      if (this.stateroom.groupType == "QIAOHU") {
        model.groupAgencyId = this.qiaohuGroup.agencyId || "";
        model.groupAgencyName = this.qiaohuGroup.agencyName || "";
        model.requestsequence = this.stateroom.requestsequence || "";
        model.groupType = this.qiaohuGroup.groupType || "";
        model.groupId = this.qiaohuGroup.groupId || "";
      }

      const errMsg = await this.onShoppingCartAdd(model);
      if (errMsg && errMsg.length > 0) {
        this.showErrMsg(errMsg);
      }

      try {
        if (window && window.gio) {
          if (model.isNrp) {
            window.gio("track", "NRP_BF01");
          }
          gioTracking("track", "AddRoom", {
            GuestNumber: model.guestNumber,
            RoomClass: model.stateroomClass,
            RoomCategory: model.stateroomCategoryCode,
						RoomType: this.stateroom.groupType == "QIAOHU" ? 'Qiaohu' : 'nil',
            shipCode: this.shipCode,
            sailDate: this.sailDate
          });
        }
      } catch (e) {
        console.error(e);
      }
    },
    shoppingCartDelete(e) {
      e.stopPropagation();
      if (this.shoppingCartNum > 0) {
        const price = this.stateroom.price.filter(
          (r) => r.isnrp == this.selectNrp
        );
        if (!price || price.length == 0) {
          return;
        }
        let model = {
          shipCode: this.shipCode,
          sailDate: this.sailDate,
          productPackageId: -1,
          packageId: this.packageCode,
          stateroomCategoryCode: this.stateroom.stateroomCategoryCode,
          stateroomClass: this.stateroomType,
          fareCode: price[0].fareCode,
          guestNumber: this.guestNumber,
          originAmount: price[0].originalAmount / this.guestNumber,
          netAmount: price[0].netAmount / this.guestNumber,
          amountPerNight: price[0].amountPerNight,
          isNrp: this.selectNrp,
          groupAgencyId: "",
          groupAgencyName: "",
          requestsequence: "",
          groupType: "",
          groupId: "",
          connectId: "",
        };
        if (this.stateroom.groupType == "QIAOHU") {
          model.groupAgencyId = this.qiaohuGroup.agencyId || "";
          model.groupAgencyName = this.qiaohuGroup.agencyName || "";
          model.requestsequence = this.stateroom.requestsequence || "";
          model.groupType = this.qiaohuGroup.groupType || "";
          model.groupId = this.qiaohuGroup.groupId || "";
        }
        this.onShoppingCartDelete(model);
      }
    },
    onStateroomClicked(e) {
      e.stopPropagation();
      gioTracking('track', 'evt_RoomDetailClick', {
        'GuestNumber': this.guestNumber,
        'RoomType': this.stateroom.groupType == "QIAOHU" ? 'Qiaohu' : 'nil',
        'RoomClass': this.stateroom.stateroomType,
        'RoomCategory': this.stateroom.stateroomCategoryCode,
        'shipCode': this.shipCode,
        'sailDate': this.sailDate
      });
      const stateroomData = {
        stateroomImages: this.stateroom.stateroomImages,
        stateroomName: this.stateroom.stateroomCNName,
        stateroomCategory: this.stateroom.stateroomCategoryCode,
        stateroomPriceType: this.priceType,
        stateroomPrice: this.netAmount,
        stateroomCapacity: this.stateroom.stateroomCapacity,
        stateroomArea: this.stateroom.stateroomArea,
        stateroomBalcony: this.stateroom.stateroomBalconyArea,
        stateroomFloor: this.stateroom.stateroomFloorInfo,
        isQiaohu: this.isQiaohu,
        isStarrySky: this.isStarrySky,
        stateroomDescription: this.stateroom.stateroomDescription,
        stateroomNrpTitle: this.nrpTitle,
        stateroomNrpText: this.nrpText,
        isNrp: this.selectNrp,
        suiteMobileImageUrl: this.stateroom.suiteMobileImageUrl,
        guestNumber: this.guestNumber,
        stateroomTag: this.stateroomTag || null,
        stateroomType: this.stateroomType || null,
        deviceFeatureTags: this.stateroom.deviceFeatureTags,
        deviceGroupTags: this.stateroom.deviceGroupTags
      };
      this.showStateroomDetail(stateroomData);
    },
    onShowStateroomSuitePopup(suiteImage) {
      console.log(suiteImage)
      if (suiteImage && suiteImage.length > 0 && this.shipCode !== 'OV') {
        this.showStateroomSuitePopup(suiteImage);
      }
    },
    onShowQiaohuPopup() {
      this.showQiaohuPopup();
    },
    onShowStarrySkyPopup() {
      this.showStarrySkyPopup();
    },
    getNrpTitle(isNrp) {
      if (this.isFortyEightHoursNrpCruise) {
        return nrpConfig.fortyEightHoursNrp.title;
      } else if (isNrp) {
        return nrpConfig.nrp.title;
      }
      return nrpConfig.rp.title;
    },
    showErrMsg(errMsg) {
      this.errMsg = errMsg;
      if (this.errMsgTimeout) {
        clearTimeout(this.errMsgTimeout);
      }
      this.errMsgTimeout = setTimeout(this.closeErrMsg, 5000);
    },
    closeErrMsg() {
      this.errMsg = "";
      if (this.errMsgTimeout) {
        clearTimeout(this.errMsgTimeout);
        this.errMsgTimeout = null;
      }
    },
  },
  computed: {
    stateroomName() {
      let name = this.stateroom.stateroomCNName + "_" + this.categoryCode;
      let guestCountText = bookingHelper.getStateroomGuestNumber(
        this.guestNumber
      );
      if (guestCountText.length > 0) {
        name += `(${guestCountText})`;
      }
      return name;
    },
    stateroomBalconyArea() {
      if (
        !this.stateroom.stateroomBalconyArea ||
        this.stateroom.stateroomBalconyArea.length == 0 ||
        this.stateroom.stateroomBalconyArea == "无"
      ) {
        return "无阳台";
      }
      return this.stateroom.stateroomBalconyArea;
    },
    priceType() {
      if (this.isFortyEightHoursNrpCruise) {
        return nrpConfig.fortyEightHoursNrp.priceType;
      } else if (this.selectNrp) {
        return nrpConfig.nrp.priceType;
      }
      return nrpConfig.rp.priceType;
    },
    nrpTitle() {
      if (this.isFortyEightHoursNrpCruise) {
        return nrpConfig.fortyEightHoursNrp.title;
      } else if (this.selectNrp) {
        return nrpConfig.nrp.title;
      }
      return nrpConfig.rp.title;
    },
    nrpText() {
      if (this.isFortyEightHoursNrpCruise) {
        return nrpConfig.fortyEightHoursNrp.description;
      } else if (this.selectNrp) {
        return nrpConfig.nrp.description;
      } else {
        return nrpConfig.rp.description;
      }
    },
    netAmount() {
      let price = 0;
      const priceObj = this.stateroom.price.filter(
        (r) => r.isnrp == this.selectNrp
      );
      price = priceObj.length > 0 ? priceObj[0].netAmount : 0;
      return price / this.guestNumber;
    },
    netAmountStr() {
      let price = this.netAmount;
      if (price == 0) {
        return "";
      }
      return price.toFixed(0);
    },
    amountPerNight() {
      if(this.selectNrp){
        return this.stateroom.price[0].amountPerNight ? this.stateroom.price[0].amountPerNight.toFixed(0) : null;
      }else{
        return this.stateroom.price[1].amountPerNight ? this.stateroom.price[1].amountPerNight.toFixed(0) : null;
      }
    },
    originalAmountStr() {
      let price = this.stateroom.originalAmount;
      if (price == 0) {
        return "";
      }
      return (price / this.guestNumber).toFixed(0);
    },
    shoppingCartNum() {
      return this.shoppingCarts.filter(
        (r) =>
          r.berthedCategoryCode == this.stateroom.stateroomCategoryCode &&
          r.isnrp == this.selectNrp &&
          (!r.connectId || r.connectId == "") &&
          r.guestNumber == this.guestNumber
      ).length;
    },
    hasNrp() {
      return this.stateroom.price && this.stateroom.price.some((r) => r.isnrp);
    },
    hasRp() {
      return this.stateroom.price && this.stateroom.price.some((r) => !r.isnrp);
    },
    isQiaohu() {
      return this.stateroom.groupType && this.stateroom.groupType == "QIAOHU";
    },
    isStarrySky() {
      return this.stateroom.groupType && this.stateroom.groupType == "STARRYSKY";
    },
    categoryCode() {
      let code = this.stateroom.stateroomCategoryCode + "";
      if (code.indexOf("_") >= 0) {
        code = code.split("_")[0];
      }
      return code;
    },
    imageUrl() {
      if (
        this.stateroom.stateroomImages &&
        this.stateroom.stateroomImages.length > 0
      ) {
        return this.stateroom.stateroomImages[0];
      }
      return this.stateroom.stateroomImgUrl;
    },
    stateroomTag() {
      return this.stateroom.suiteType;
    },
    isBirthday() {
      if (
        this.specialBookingInfo &&
        this.specialBookingInfo.specialBookingType > 0
      ) {
        return (
          this.specialBookingInfo.specialBookingType ==
          SpecialBookingType.Birthday
        );
      }
      return false;
    },
  },
  watch: {
    stateroom() {
      this.initSelectNrp();
    },
    suiteTagSelected(val) {
      if(this.stateroom.suiteType) {
        let suiteType = this.stateroom.suiteType;
        if(this.stateroom.stateroomType === 'DELUXE') {
          this.stateroomShow = true;
          if(val === 1) {
            this.stateroomShow = suiteType === 1;
          } else if(val === 2) {
            this.stateroomShow = suiteType === 2;
          } else if(val === 3) {
            this.stateroomShow = suiteType === 3;
          }
        }
      }
    }
  },
};
</script>

<style lang="less" scoped>
li.stateroomItem {
  margin-bottom: 10px;
  border: 1px solid #d3dadd;
  border-right: 0;
  position: relative;
}

.list_box {
  border-right: 7px solid #fbc500;
  padding: 10px;
  position: relative;
  .img_box {
    position: relative;
    width: 280px;
    height: 200px;
    overflow: hidden;
    margin-right: 30px;
    img {
      width: 100%;
      cursor: pointer;
    }
    & .qiaohu_tag {
      position: absolute;
      top: 10px;
      left: 10px;
      height: 37px;
      width: auto;
    }
    & .suite-tag {
      position: absolute;
      top: 10px;
      left: 10px;
      width: auto;
    }
  }
  .ship_info {
    margin-bottom: 40px;
    .ship_title {
      font-size: 22px;
      color: #282b2c;
      font-weight: bold;
      margin-bottom: 10px;
      a {
        display: inline-block;
        font-size: 16px;
        color: #0073bb;
        margin-left: 10px;
        vertical-align: middle;
        font-weight: normal;
        line-height: 23px;
        cursor: pointer;
      }
      .offer_label {
        line-height: 23px;
        padding: 0 20px;
        background-color: #fffae7;
        border-radius: 12px;
        border: solid 1px #ffa70d;
        display: inline-block;
        font-size: 12px;
        color: #ffa70d;
        font-weight: normal;
        margin: 0 10px;
        vertical-align: middle;
        cursor: pointer;
      }
      .deluxe-tag {
        margin: -2px 10px 0;
        height: 23px;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    .ship_parameter {
      font-size: 14px;
      color: #a6aeb1;
      span {
        display: inline-block;
        vertical-align: middle;
        margin-right: 10px;
        padding-right: 10px;
        position: relative;
      }
      span::after {
        content: "";
        display: block;
        width: 1px;
        height: 12px;
        background: #b4b4b4;
        position: absolute;
        right: 0;
        bottom: 3px;
      }
      span:last-child::after {
        background: transparent;
      }
    }

    .ship_tags {
      margin-top: 8px;
      & .tag {
        display: inline-block;
        margin-right: 25px;

        & > img {
          display: inline-block;
          height: 14px;
          margin-right: 5px;
        }
        & > div {
          line-height: 14px;
          font-size: 13px;
          color: #282b2c;
          display: inline-block;
        }
      }
    }
    .stateroom_Detail {
      cursor: pointer;
      color: #2b77bd;
      & > span {
        display: inline-block;
        margin-right: 4px;
      }
      & > img {
        margin-bottom: 2px;
        display: inline-block;
      }
    }
  }

  .price {
    .price-num {
      font-size: 14px;
      height: 34px;
      color: #282b2c;
      em {
        color: #ff3022;
        font-style: normal;
        font-weight: bold;
      }
      & .symbol {
        font-size: 18px;
        height: 34px;
      }
      .num {
        color: #ff3022;
        font-size: 28px;
        font-weight: bold;
        line-height: 34px;
      }
      .average-price {
        margin-left: 25px;
        color: #a6aeb1;
      }
    }
    .offer_price {
      font-size: 14px;
      margin-bottom: 0;
      em {
        color: #ff3022;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
      }
      .num {
        color: #ff3022;
        font-size: 20px;
        font-weight: bold;
      }
    }
    .original_price {
      font-size: 14px;
      display: block;
    }
    .return_label {
      font-size: 0;
      display: inline-block;
      margin-top: 10px;
      cursor: pointer;
      margin-right: 5px;
      background: url(https://resource.rcclchina.com.cn/tui2/list/NRP_Bg.png)
        no-repeat;
      background-size: 100% 100%;
      filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='https://resource.rcclchina.com.cn/tui2/list/NRP_Bg.png',sizingMethod='scale');
      -ms-filter: "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='https://resource.rcclchina.com.cn/tui2/list/NRP_Bg.png',sizingMethod='scale')";
      span {
        width: 75px;
        display: inline-block;
        height: 25px;
        line-height: 25px;
        border-radius: 13px;
        font-size: 12px;
        text-align: center;
      }
      span.cur {
        background: url(https://resource.rcclchina.com.cn/tui2/list/NRP_Selected.png)
          no-repeat;
        background-size: 100% 100%;
        filter: progid:DXImageTransform.Microsoft.AlphaImageLoader(src='https://resource.rcclchina.com.cn/tui2/list/NRP_Selected.png',sizingMethod='scale');
        -ms-filter: "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='https://resource.rcclchina.com.cn/tui2/list/NRP_Selected.png',sizingMethod='scale')";
        color: #fff;
      }
    }
    .specialBookingStateroom_title {
      font-size: 0px;
      display: inline-block;
      margin-top: 16px;
      margin-right: 5px;
      background-size: 100% 100%;
      span {
        width: 137px;
        display: inline-block;
        color: #818181;
        height: 25px;
        line-height: 25px;
        border-radius: 13px;
        font-size: 14px;
        text-align: center;
      }
      .button {
        text-align: left;
        display: inline-block;
        height: 25px;
        line-height: 25px;
        border-radius: 13px;
        font-size: 14px;
        color: #BA9153;
        cursor: pointer;
      }
      img {
        //height: 27px;
        width: 27px;
      }
    }
  }

  .f-fr {
    margin: 90px 46px 0px 0px;
    position: relative;
    z-index: 2;
  }

  .detail_add_btn {
    span {
      position: relative;
      width: 30px;
      height: 30px;
      border: 1px solid #d3dadd;
      background: #fff;
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }
    input {
      width: 36px;
      height: 30px;
      border: none;
      padding: 0;
      margin: 0 3px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      font-style: normal;
    }
    span:after {
      width: 18px;
      height: 2px;
      left: 50%;
      margin-left: -8px;
      top: 13px;
    }
    .add:before {
      height: 18px;
      width: 2px;
      left: 50%;
      top: 13px;
      margin-top: -8px;
    }
  }
  .detail_add_btn span:after,
  .detail_add_btn span:before {
    content: "";
    display: block;
    position: absolute;
    background: #016bb9;
  }
  .detail_add_btn .disabled:after,
  .detail_add_btn .disabled:before {
    background: #a6aeb1;
  }
  .c_surplus_room_num {
    margin-top: 10px;
    color: #ff3022;
  }
  .errMsg {
    margin: 5px -101px 0px 0px;
    position: absolute;
    top: 132px;
    right: 153px;
    color: white;
    height: 50px;
    background: rgb(51, 136, 199);
    /* line-height: 32px; */
    display: flex;
    align-items: center;
    padding: 5px 10px 5px 28px;
    img {
      cursor: pointer;
    }
    .errMsgText {
      padding-right: 10px;
    }
  }
  .hover-bg {
    background-image: url(https://resource.rcclchina.com.cn/tui2/detail/part3_list_hover_bj.png);
    background-repeat: no-repeat;
    background-position: top right;
    background-size: 100% 100%;
    position: absolute;
    width: 0px;
    top: 0px;
    right: -7px;
    height: 100%;
    -webkit-transition: width 0.5s ease;
    -o-transition: width 0.5s ease;
    -moz-transition: width 0.5s ease;
    transition: width 0.5s ease;
  }
}

.list_box:hover .hover-bg {
  width: 222px;
  -webkit-transition: width 0.5s ease;
  -o-transition: width 0.5s ease;
  -moz-transition: width 0.5s ease;
  transition: width 0.5s ease;
}

li.special-stateroom-qiaohu {
  background: url(https://resource.rcclchina.com.cn/QIAOHU/PC/QH-BG.png)
    no-repeat top center;
  .list_box {
    border: 4px solid #ffe100;
    border-right: 7px solid #fbc500;
    padding: 7px;
  }
}
li.special-stateroom-starrySky {
  background: url(https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_detail_bg.png)
  no-repeat top center;
  .list_box {
    border: 4px solid #ffe100;
    border-right: 7px solid #fbc500;
    padding: 7px;
  }
}
</style>
